// extracted by mini-css-extract-plugin
module.exports = {"TableTitle":"TableTitle_TableTitle__1_xGC","arrows":"TableTitle_arrows__3kYjt","title":"TableTitle_title__3EV0p"};